import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Address, AddressValidator, EmailAddressValidator, PhoneNumberValidator, Radio, RequiredValidator, TextField, Actions, ULID } from '../../Components/Form';
import Conditional from '../../Components/Form/Conditional';
import { useCustomer } from '../../Data/Customers';
import API from '../../Services/API';
import { useToasts } from '../../Components/Toasts';

const EditCustomer = (params) => {
    return params.customerId ? <DoEditCustomer {...params} /> : <DoAddCustomer {...params} />;
}

const DoAddCustomer = ({isOpen, onClose, onSave}) => {
    const {showSuccess, showError} = useToasts();

    const doSave = (data) => {
        return API.post('/customers', data)
            .then(() => {
                showSuccess('Customer added')
                onSave && onSave(data.customerId);
            })
            .catch((err) => showError(API.parseErrorResponse(err)));
    }

    return <TheModal title="Add customer" customer={{}} isOpen={isOpen} onClose={onClose} doSave={doSave} />
}

const DoEditCustomer = ({customerId, customer, isOpen, onClose, onSave}) => {
    const {updateCustomer} = useCustomer(customerId, true);

    const doSave = async (data) => {
        await updateCustomer(data);
        onSave && onSave();
    }

    if (!customerId) {
        return null;
    }

    return <TheModal title="Edit customer" customer={customer} isOpen={isOpen} onClose={onClose} doSave={doSave} />
}

const TheModal = ({title, customer, isOpen, onClose, doSave}) => {
    return <Modal title={title} isOpen={isOpen} setIsOpen={onClose} dismissible>
        <Form onSubmit={doSave} data={customer} closeModalOnSubmit>
            <TextField label="Name" name="name" />
            <Radio label="Customer Type" name="type" layout="SmallCards" options={[
                {
                    label: 'Individual',
                    value: 'Individual',
                },
                {
                    label: 'Business',
                    value: 'Business',
                },
                {
                    label: 'Unknown',
                    value: 'Unknown',
                },
            ]} validators={[RequiredValidator]} />
            <Conditional condition={formData => formData.type === 'Business'}>
                <TextField label="Business name" name="businessName" type="text" validators={[]} />
            </Conditional>
            <TextField label="Email" name="email" type="email" validators={[EmailAddressValidator]} />
            <TextField label="Phone number" name="phoneNumber" type="tel" validators={[PhoneNumberValidator]} />
            <Address label="Address" name="address" validators={[AddressValidator]} />
            <ULID name="customerId" />
            <Actions submit cancel />
        </Form>
    </Modal>
}

export default EditCustomer;
